import React from 'react';
import { useSite } from 'app/contexts/SiteContext.js';
import { useObservation } from 'app/contexts/ObservationContext';
import { Breadcrumb } from 'app/components';
import ARImageGallery from './ARImageGallery';

const ARImagePage = () => {
  const { siteInfo, org } = useSite();
  const { arImages } = useObservation();

  const arImagesArray = Object.values(arImages.arImages) || [];

  return (
    <div>
      <Breadcrumb
        routeSegments={[
          ...(org?.id
            ? [
              {
                name: org.name,
                path: `/org/${org.id}`,
              },
              { name: siteInfo.siteName, path: `/site/${siteInfo.id}` },
              {
                name: 'AR Photo Gallery',
                path: `/site/${siteInfo.id}/observations/ar-image-gallery`,
              },
            ]
            : [
              { name: siteInfo.siteName, path: `/site/${siteInfo.id}` },
              {
                name: 'AR Photo Gallery',
                path: `/site/${siteInfo.id}/observations/ar-image-gallery`,
              },
            ]),
        ]}
      />

      <ARImageGallery images={arImagesArray} projectId={siteInfo.id} />
    </div>
  );
};

export default ARImagePage;
